<template>
    <v-dialog 
        v-model="dialogResStorno" 
        class="dialogStorno"
        transition="dialog-top-transition"
        :scroll-strategy="'none'"
        >
        <v-card flat class="pa-3">
            <v-row class="align-center justify-end">
                <v-col cols="auto">
                    <ExitButton @click="dialogResStorno=false"/>
                </v-col>
            </v-row>
            <v-row dense class="align-center justify-begin mt-n8">
                <v-col cols="auto">
                    <v-card-title>Information</v-card-title>
                </v-col>
            </v-row>
            <v-row dense class="align-center justify-center">
                <v-col cols="auto">
                    <v-card-subtitle>
                        <template v-if="isSingle">
                            Sind Sie sicher, dass Sie die ausgewählte Reservierung stornieren möchten ? <br>
                            Dieser Vorgang kann nicht rückgängig gemacht werden!
                        </template>
                        <template v-else>
                            Sind sie sicher, dass Sie die <strong>{{ countRes }}</strong> ausgewählten Reservierungen stornieren möchten ? <br>
                            Dieser Vorgang kann nicht rückgängig gemacht werden!
                        </template>

                    </v-card-subtitle>
                </v-col>
            </v-row>
            <v-row class="justify-end mt-n3 mb-n3">
                <v-col cols="auto">
                    <v-card-actions>
                        <v-btn @click="confirmStorno" variant="elevated" color="red" class="btn-responsive">Stornierung bestätigen</v-btn>
                        <v-btn @click="dialogResStorno=false" variant="elevated" color="grey" class="btn-responsive">Abbrechen</v-btn>
                    </v-card-actions>
                </v-col>
            </v-row> 
        </v-card>
    </v-dialog>
    <SnackbarResStorno ref="snackbarResStornoRef" />
</template>

<script>

import ExitButton from '../consumables/ExitButton.vue';
import SnackbarResStorno from '../consumables/SnackbarResStorno.vue';

export default{
    name:'ReservationStornoDialog',
    emits: ['stornoReservation'],

    components:{
        SnackbarResStorno,
        ExitButton
    },

    data(){
        return{
            dialogResStorno: false,
            internalRes: []
        }
    },

    props:{
        resStornoDialogReservations: { type: [Object, Array], default: () => [] }
    },

    computed: {
        isSingle() {
            return this.resStornoDialogReservations.length === 1
        },
        countRes() {
            return this.resStornoDialogReservations.length
        }
    },

    methods:{
        openDialogResStorno() {
            this.internalRes = Array.isArray(this.resStornoDialogReservations)
                ? this.resStornoDialogReservations
                : [this.resStornoDialogReservations]    
            this.dialogResStorno = true
        },

        async confirmStorno() {
            await this.deleteRes()
            this.dialogResStorno = false
        },

        async deleteRes() {
            try {
                for (const res of this.internalRes) {
                    await this.$axios.delete(`/api/reservations/${res.id}/`);
                }
                this.$refs.snackbarResStornoRef.show()
                this.$emit('stornoReservation')
            } catch (error) {
                console.error('Fehler beim Löschen:', error)
            }
        }
    }
}
</script>

<style scoped>

.dialogStorno{
    max-width: 640px;
}

@media (max-width: 600px) {
  .btn-responsive {
    font-size: 0.5rem;
    height: 1rem !important;
    margin-top: -1rem
  }
  .v-card-subtitle {
    font-size: 0.5rem;
    margin-top: -1rem;
  }
  .v-card-title {
    font-size: 0.75rem;
    margin-left: -1rem;
  }
  .v-card {
    overflow: hidden !important;
  }
  .dialogStorno {
    max-height: 10rem;
  }
}
</style>